<template>
  <label
    v-if="Array.isArray(checked)"
    class="checkbox"
    :class="[{ disabled: disabled }, { checked: checked.includes(value) || isIndeterminate }]"
    :style="masterStyle">
    <i v-if="checked.includes(value)" class="icon icon-check text-light1 checkbox--no-height" :style="iconStyle" />
    <i v-else-if="isIndeterminate" class="icon icon-rectangle text-light1 checkbox--no-height" :style="iconStyle" />
    <input
      class="checkbox"
      type="checkbox"
      :checked="checked.includes(value)"
      :value="value"
      :disabled="disabled"
      @change="click" />
  </label>

  <label
    v-else
    class="checkbox"
    :class="[{ disabled: disabled }, { checked: checked || isIndeterminate }]"
    :style="masterStyle">
    <i v-if="checked" class="icon icon-check text-light1 checkbox--no-height" :style="iconStyle"></i>
    <i v-else-if="isIndeterminate" class="icon icon-rectangle text-light1 checkbox--no-height" :style="iconStyle" />
    <input v-model="val" class="controller" type="checkbox" :value="value" :disabled="disabled" @change="toggle" />
  </label>
</template>

<script>
const DEFAULT_CHECKBOX_SIZE = 16;
const DEFAULT_BORDER_SIZE = 1;

export default {
  name: 'Checkbox',
  model: {
    prop: 'checked',
    event: 'update',
  },
  props: {
    checked: [Array, Boolean],
    value: [Object, String, Number, Boolean, Array],
    readonly: {
      type: Boolean,
      default: false,
    },
    size: {
      type: [Number, String],
      default: 16,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    isIndeterminate: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:checked'],
  data() {
    return {
      val: false,
    };
  },
  computed: {
    toggleClass() {
      return this.val ? 'on' : 'off';
    },

    masterStyle() {
      const borderWidth =
        this.sizeNum - DEFAULT_CHECKBOX_SIZE < 0 ? 1 : ((this.sizeNum - DEFAULT_CHECKBOX_SIZE) * 0.25) / 4 + 1;

      return {
        width: this.sizeNum + this.sizeUnit,
        height: this.sizeNum + this.sizeUnit,
        borderWidth: borderWidth + this.sizeUnit,
      };
    },

    sizeNum() {
      if (typeof this.size == 'number') {
        return this.size;
      }
      const size = this.size;
      const parts = size.split(/([a-zA-Z%]+)/);
      return Number(parts[0]) || 16;
    },

    sizeUnit() {
      if (typeof this.size == 'number') {
        return 'px';
      }
      const size = this.size;
      const parts = size.split(/([a-zA-Z%]+)/);
      return parts[1] || 'px';
    },

    iconStyle() {
      return {
        fontSize: (this.sizeNum * 5) / 8 + this.sizeUnit,
      };
    },
  },
  watch: {
    checked(newV) {
      if (this.val != newV) this.val = newV;
    },
  },
  created() {
    this.val = this.checked;
  },

  methods: {
    toggle() {
      if (this.disabled || this.readonly) {
        return;
      }

      this.$emit('update:checked', this.val);
    },
    click() {
      if (this.disabled || this.readonly) {
        return;
      }
      const newChecked = [...this.checked];
      if (this.checked.includes(this.value)) {
        newChecked.splice(newChecked.indexOf(this.value), 1);
      } else {
        newChecked.push(this.value);
      }

      this.$emit('update:checked', newChecked);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/app/editor/scss/variables';
@import '@/core/themes/vendor/color';
@import '@/core/themes/vendor/variables';
@import '@/core/themes/vendor/mixins';

label {
  padding: 0;
}
.checkbox {
  border: solid 1px #dddde3;
  outline: 2px solid transparent;
  background-color: #ffffff;
  border-radius: 4px;
  @include flex-center;
  // @include trans-all;
  input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }
  &:not(.disabled):hover {
    border-color: $mono3;
    outline-color: rgba(26, 148, 255, 0.2);
    cursor: pointer;
  }

  &.checked {
    background: $mono3;
    border-color: $mono3;

    &:hover {
      outline-color: rgba(26, 148, 255, 0.2);
    }
  }
  &--no-height {
    line-height: 0;
  }
}
</style>
